import { Matters } from '../matters/Matters';

export const MattersPage = () => {
  return (
    <div className="w-full">
      <Matters />
    </div>
  );
};
